export const EMAIL_MEDIA_TYPE = 0;
export const CHAT_MEDIA_TYPE = 1;
export const SMS_MEDIA_TYPE = 2;
